import styled from 'styled-components';
import { backgroundColor2, fontSize2 } from './../Shared/Styles';

export default styled.select`
  ${backgroundColor2}
  ${fontSize2}
  border: 1px solid;
  color: #1163c9;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
`;
